import { useEffect } from 'react';
import { SignUp } from '@clerk/clerk-react';
import {
  AuthPageLayout,
  LeftBrandContainer,
  LeftBrandContent,
  RightContentArea,
} from '../../components/auth/SharedAuthComponents';
import { track } from '../../services/analytics';
import { withMarketingParams } from '../../services/googleAds';

export default function IndividualSignUpPage() {
  useEffect(() => {
    track('signup_started', { signup_type: 'individual' });
  }, []);

  return (
    <AuthPageLayout>
      <LeftBrandContainer>
        <LeftBrandContent
          title="CPE Compliance Without the Guesswork"
          subtitle="No more wondering if your team has met their CPE requirements. CPAx Academy tracks every hour in real time and shows you exactly where each person stands - all NASBA-approved, all in one place."
        />
      </LeftBrandContainer>

      <RightContentArea>
        <SignUp
          signInUrl="/auth/login"
          forceRedirectUrl={withMarketingParams('/auth/individual-plans')}
        />
      </RightContentArea>
    </AuthPageLayout>
  );
}
